import React, { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import DeleteDialogModal from "../../control-components/custom-delete-dialog-box/delete-dialog";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import { NotificationManager } from "src/util/notify";
import Loader from "../../control-components/loader/loader";
import InputKendoRct from "../../control-components/input/input";


const DocumentTemplateInfo = ({ onClose, selectedTemplateInfo, regionId, getAllDefaultDocumentTemplates }) => {
    const [clinicList, setClinicList] = useState(selectedTemplateInfo?.assignedClinic || []);
    const [defaultclinicList, setDefaultClinicList] = useState(selectedTemplateInfo?.assignedClinic || []);
    const [selectedId, setSelectedId] = useState("");
    const [isDeleteConfirm, setDeleteConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState("")

    const deleteSelectId = (masterClinicId) => {
        setDeleteConfirm(!isDeleteConfirm);
        setSelectedId(masterClinicId);
    }

    const unassignDocumentTemplate = async () => {
        setLoading(true);
        await fileDocumentService
            .unassignDocumentTemplate(selectedId, regionId, selectedTemplateInfo)
            .then((result) => {
                setLoading(false);
                setDeleteConfirm(!isDeleteConfirm);
                setClinicList(clinicList.filter(item => item.masterClinicId !== selectedId));
                NotificationManager.success("Document template deleted successfully.");
                getAllDefaultDocumentTemplates()
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error);
                setDeleteConfirm(!isDeleteConfirm);
            });
    }
    const handleFilter = (e) => {
        if (e.target.value === "") {
            setClinicList(defaultclinicList)
        }
        else {
          const filterResult = (defaultclinicList.filter((item) =>
          (item?.clinicName?.toLowerCase().includes(e.target.value.toLowerCase())
            || Number(item.masterClinicId).toString().includes(e.target.value.toString())
             ||  Number(item.clinicId).toString().includes(e.target.value.toString()))
        ))
            setClinicList(filterResult)
        }
        setSearchText(e.target.value)
      }

      const sortedclinicList = [...clinicList].sort((a, b) => a.clinicName.localeCompare(b.clinicName));

    return (
        <div>
            {loading && <Loader />}
            <Dialog
                onClose={onClose}
                title={"Assigned Clinic "}
                height={500}
                width={800}
            >
        <div className="col-lg-3 col-md-6 col-12 " style={{ paddingLeft: "0px" ,paddingBottom:"20px"}}>
          <InputKendoRct
            value={searchText}
            onChange={handleFilter}
            name="searchContent"
            className="form-control"
            placeholder={" Search "}
          />
        </div>
                <div className="edit-client-popup">
                    <div className="popup-modal ">
                        <Grid
                            data={sortedclinicList}
                            style={{
                                height: sortedclinicList?.length > 0 ? "100%" : "350px",
                            }}
                            checkboxElement
                        >
                            <GridColumn
                                className="cursor-default"
                                field="masterClinicId"
                                title="Master Clinic ID"
                                cells={{
                                    data: (props) => {
                                        let field = props?.dataItem
                                        return <td className="cursor-default">{field?.masterClinicId}</td>;
                                    }
                                }}
                            />

                            <GridColumn
                                className="cursor-default"
                                field="clinicId"
                                title="Clinic ID"
                                cells={{
                                    data: (props) => {
                                        let field = props?.dataItem
                                        return <td className="cursor-default">{field?.clinicId}</td>;
                                    }
                                }}
                            />
                            <GridColumn
                                className="cursor-default"
                                field="clinicName"
                                title="Clinic Name"
                                cells={{
                                    data: (props) => {
                                        let field = props?.dataItem
                                        return <td className="cursor-default">{`${field?.clinicName}`}</td>;
                                    }
                                }}
                            />
                            <GridColumn
                                title="Action"
                                filterable={false}
                                cells={{
                                    data: (props) => {
                                        const masterClinicId = props?.dataItem?.masterClinicId;
                                        return (
                                            <td>
                                                <div className="row-3">
                                                    <div
                                                        className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-red"
                                                        onClick={() => deleteSelectId(masterClinicId)}
                                                    >
                                                        <div className="k-chip-content">
                                                            <Tooltip anchorElement="target" position="top">
                                                                <i
                                                                    className="fa fa-trash"
                                                                    aria-hidden="true"
                                                                    title="Delete"
                                                                >
                                                                </i>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                            </td>
                                        );
                                    }
                                }}
                            />
                        </Grid>
                    </div>
                </div>
                {isDeleteConfirm && (
                    <DeleteDialogModal
                        onClose={deleteSelectId}
                        title="Document Template"
                        message="document template"
                        handleDelete={unassignDocumentTemplate}
                    />
                )}
            </Dialog>
        </div>
    );
};
export default DocumentTemplateInfo;
